var map = {
	".": "cKxm",
	"./": "cKxm",
	"./RankingTable": "w0PT",
	"./RankingTable.js": "w0PT",
	"./data": "n8yD",
	"./data.js": "n8yD",
	"./images/gift.svg": "fLb8",
	"./images/mobile/DOCK_app-CN.jpg": "DOC2",
	"./images/mobile/DOCK_app-EN.jpg": "/Sm6",
	"./images/mobile/NPXS_app-CN.jpg": "vhwh",
	"./images/mobile/NPXS_app-EN.jpg": "jpH4",
	"./images/mobile/chz-banner-cn.jpg": "fBue",
	"./images/mobile/chz-banner-en.jpg": "D2vf",
	"./images/mobile/usdt_app_cn.png": "a2u4",
	"./images/mobile/usdt_app_en.png": "Qt+H",
	"./images/pc/DOCK_landing_page-CN.jpg": "oKnK",
	"./images/pc/DOCK_landing_page-EN.jpg": "k2NH",
	"./images/pc/NPXS_landing-CH.jpg": "sUZI",
	"./images/pc/NPXS_landing-EN.jpg": "NFjR",
	"./images/pc/chz-banner-cn.jpg": "Pas2",
	"./images/pc/chz-banner-en.jpg": "lXvW",
	"./images/pc/usdt_web_cn.png": "MmDd",
	"./images/pc/usdt_web_en.png": "xx+X",
	"./images/rankingNo_1.svg": "oDNX",
	"./images/rankingNo_2.svg": "mo6j",
	"./images/rankingNo_3.svg": "HNUu",
	"./images/star.svg": "byWg",
	"./images/vector.svg": "ZxVK",
	"./images/vote-banner.png": "e9EY",
	"./images/vs.svg": "g8Hj",
	"./index": "cKxm",
	"./index.js": "cKxm",
	"./usdt": "K7H5",
	"./usdt.js": "K7H5",
	"./usdtData": "1tYK",
	"./usdtData.js": "1tYK",
	"./usdtRankingTable": "c8NQ",
	"./usdtRankingTable.js": "c8NQ",
	"./vote": "I2hp",
	"./vote.js": "I2hp",
	"./voteText": "REya",
	"./voteText.js": "REya"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jBru";